import PhishingS1 from "@/assets/png/Phishing/PhishingS1.png";
import PhishingS2 from "@/assets/png/Phishing/PhishingS2.png";
import PhishingS3 from "@/assets/png/Phishing/PhishingS3.png";
import PhishingS4 from "@/assets/png/Phishing/PhishingS4.png";
import PhishingS5 from "@/assets/png/Phishing/PhishingS5.png";
import PhishingS6 from "@/assets/png/Phishing/PhishingS6.png";

import { Answer, IQuizList, ISlides } from "@/pages/SecurityAwareness/types";

export const phishingQuiz: Array<IQuizList> = [
  {
    name: "step1",
    question: "1. What is the main goal of phishing and social engineering?",
    options: [
      { value: "1", label: "To test employee knowledge" },
      { value: "2", label: "To improve security software" },
      {
        value: Answer.Correct,
        label: "To trick individuals into revealing sensitive information",
      },
      { value: "4", label: "To make websites load faster" },
    ],
  },
  {
    name: "step2",
    question: "2. What should you do before clicking on a link in an email?",
    options: [
      {
        value: "1",
        label: "Click as soon as you see the email",
      },
      {
        value: "2",
        label: "Report the email to your manager",
      },
      {
        value: Answer.Correct,
        label: "Hover over the link to preview the real URL before clicking",
      },
      { value: "4", label: "Ignore the email" },
    ],
  },
  {
    name: "step3",
    question: "3. Which of the following is NOT recommended?",
    options: [
      {
        value: Answer.Correct,
        label: "Sharing your password over chat",
      },
      {
        value: "2",
        label: "Checking sender email addresses",
      },
      {
        value: "3",
        label: "Reporting suspicious messages",
      },
      {
        value: "4",
        label: "Using different passwords for each account",
      },
    ],
  },
  {
    name: "step4",
    question: "4. What is a common sign of a phishing email?",
    options: [
      { value: "1", label: "A well-formatted layout" },
      {
        value: Answer.Correct,
        label: "Sender email like security@paypaI.com",
      },
      { value: "3", label: "Friendly tone" },
      {
        value: "4",
        label: "Subject line that matches your work",
      },
    ],
  },
  {
    name: "step5",
    question: "5. What should you do if you receive a suspicious email?",
    options: [
      { value: "1", label: "Ignore it and move on" },
      { value: "2", label: "Reply to verify its origin" },
      {
        value: Answer.Correct,
        label: "Report it to IT or the security team",
      },
      { value: "4", label: "Delete it without reading" },
    ],
  },
];

export const phishingSlides: Array<ISlides> = [
  { id: 1, content: <img src={PhishingS1} alt="slide1" /> },
  { id: 2, content: <img src={PhishingS2} alt="slide2" /> },
  { id: 3, content: <img src={PhishingS3} alt="slide3" /> },
  { id: 4, content: <img src={PhishingS4} alt="slide4" /> },
  { id: 5, content: <img src={PhishingS5} alt="slide5" /> },
  { id: 6, content: <img src={PhishingS6} alt="slide6" /> },
];
